module.exports = __webpack_public_path__ + "media/images/icons/lightbulb2x-988e147ae6c27e9eb957f4c8bd0c4a7a.png";